/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit LinkAction/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import Copy from 'DesignSystem/Copy/index'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import TysiaTextLink from 'DesignSystem/TysiaTextLink/index'
import Tysiav2Launch from 'DesignSystem/Svgs/Tysiav2Launch/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function LinkAction({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/TreatmentCard/Content/TreatmentPlans/Steps/Content/Contracts/Content/Payor/Content/SignAction/Content/Content/LinkAction"
  
}) {
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let payorContractSignatureRequestIdValueData = fromData.useDataValue({ viewPath,
context: 'payor',
path: 'contract.signature_request.id',
})
let aggregateData = fromHelpers.getSignatureRequestUrl(payorContractSignatureRequestIdValueData)
let dtColorsNeutral500 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.500'
        })
let payorContractSignatureRequestIdValueData1 = fromData.useDataValue({ viewPath,
context: 'payor',
path: 'contract.signature_request.id',
})
let aggregateData1 = fromHelpers.getSignatureRequestUrl(payorContractSignatureRequestIdValueData1)
  return (<React.Fragment
>
<div
  data-testid="LinkAction.Horizontal"
  data-view-path={viewPath}
 style={{'--g-1-Z2lECbk': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs}}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 text="URL:"
/>
<TysiaTextLink
  viewPath={`${viewPath}/TysiaTextLink`}
 data="payor.contract.signature_request.id"
 aggregate="helpers.js getSignatureRequestUrl"
 goTo={aggregateData}
 text={aggregateData}
 maxWidth={200}
/>
<Tysiav2Launch
  viewPath={`${viewPath}/Tysiav2Launch`}
 flexShrink={0}
 width={16}
 height={16}
 stroke={dtColorsNeutral500}
/>
<Copy
  viewPath={`${viewPath}/Copy`}
 marginLeft={0}
 data="payor.contract.signature_request.id"
 aggregate="helpers.js getSignatureRequestUrl"
 value={aggregateData1}
 text="Copy signature request link"
/>
</div>
{children}
</React.Fragment>)
}